import Header from 'components/VerticalLayout/Header'
import React from 'react'
import bgImage from "../../../assets/images/bgImage1.jpg";
import { Card, Col, Container, Row } from 'reactstrap';
import IconCardButton from '../IconCardButton ';
import { FaProductHunt } from "react-icons/fa";
import { SiBitcoincash } from "react-icons/si";
import { useNavigate } from 'react-router-dom';

const ProductsPage = () => {
    document.title = "Title Appraiser | Products"
    const navigate = useNavigate();

  return (
    <div className='account'>
        <Header/>
        <div className='accountbg'
            style={{
                background: `url(${bgImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundAttachment:"fixed",
                paddingTop:"80px",
                minHeight:"100vh",
                overflowX:"auto",
                paddingLeft:"8px"
                }}
        >
           <Container fluid className='py-2' style={{paddingLeft:"20px",paddingRight:"20px"}}>
                <Card style={{height:"100vh"}} className='align-items-center justify-content-center'>
                    <Row>
                        <Col xs="auto">
                            <IconCardButton icon={FaProductHunt} title="Product Customization" onClick={()=> navigate('/product-customization')}/>
                        </Col>
                        <Col xs="auto">
                            <IconCardButton icon={SiBitcoincash} title="Product Pricing" onClick={()=> navigate('/product-pricing')}/>
                        </Col>
                    </Row>
                </Card>
           </Container>
        </div>
    </div>
  )
}

export default ProductsPage
